<div *ngFor="let app of applications">
  <app-doctors-station-reset-password
    *ngIf="isStation && app.clientId === clientId"
    [_csrf]="_csrf"
    [ticket]="ticket"
    [email]="email"
    [clientId]="clientId"
  ></app-doctors-station-reset-password>
  <app-dr-dish-reset-password
    *ngIf="app.type === 'dr-dish' && app.clientId === clientId"
    [_csrf]="_csrf"
    [ticket]="ticket"
    [email]="email"
    [clientId]="clientId"
  ></app-dr-dish-reset-password>
  <app-suguyaku-reset-password
    *ngIf="app.type === 'suguyaku' && app.clientId === clientId"
    [_csrf]="_csrf"
    [ticket]="ticket"
    [email]="email"
    [clientId]="clientId"
  ></app-suguyaku-reset-password>
  <app-doctors-next-reset-password
    *ngIf="app.type === 'dnext' && app.clientId === clientId"
    [_csrf]="_csrf"
    [ticket]="ticket"
    [email]="email"
    [clientId]="clientId"
  ></app-doctors-next-reset-password>
  <app-collabo-portal-reset-password
    *ngIf="app.type === 'cportal' && app.clientId === clientId"
    [_csrf]="_csrf"
    [ticket]="ticket"
    [email]="email"
    [clientId]="clientId"
  ></app-collabo-portal-reset-password>
  <app-sgzp-app2-reset-password
    *ngIf="app.type === 'cportal-sgzp-app2' && app.clientId === clientId"
    [_csrf]="_csrf"
    [ticket]="ticket"
    [email]="email"
    [clientId]="clientId"
  ></app-sgzp-app2-reset-password>
  <app-sas-station-reset-password
    *ngIf="app.type === 'sas-station' && app.clientId === clientId"
    [_csrf]="_csrf"
    [ticket]="ticket"
    [email]="email"
    [clientId]="clientId"
  ></app-sas-station-reset-password>
</div>
<app-dynamic-component-host #dynamicComponentHost></app-dynamic-component-host>
